import React from "react"
import "./style.css"

const Wrapper = () => {
  const data = [
    {
      // cover: <i class='fa-solid fa-truck-fast'></i>,
      title: "Today's Deal",
      // decs: "We offer competitive prices on our 100 million plus product any range.",
      link:"https://amzn.to/3zu2P3E"
    },
    {
      // cover: <i class='fa-solid fa-id-card'></i>,
      title: "Best Sellers",
      // decs: "We offer competitive prices on our 100 million plus product any range.",
      link:"https://amzn.to/43928u0"
    },
    {
      // cover: <i class='fa-solid fa-shield'></i>,
      title: "Hot New Releases",
      // decs: "We offer competitive prices on our 100 million plus product any range.",
      link:"https://amzn.to/3ZHEYYL"
    },
    {
      // cover: <i class='fa-solid fa-headset'></i>,
      title: "60%-80% Off",
      // decs: "We offer competitive prices on our 100 million plus product any range.",
      link:"https://amzn.to/3zu3jH0"
    },
  ]
  return (
    <>
      <section className='wrapper background'>
        <div className='container grid2'>
          {data.map((val, index) => {
            return (
              <div className='product' key={index}>
                {/* <div className='img icon-circle'>
                  <i>{val.title}</i>
                </div> */}
                <a href={val.link} style={{color:"red", fontWeight:"bold"}}>{val.title}</a>
                {/* <p>{val.decs}</p> */}
              </div>
            )
          })}
        </div>
      </section>
    </>
  )
}

export default Wrapper
